import React from 'react';
import './advance-payment-action-card.scss';
import { ReactComponent as InfoIcon } from '@zonofi/svg-icons/input-info.svg';
import { getFormattedAmount } from '@zonofi/common/functions/format-amount';
import { SpinnerLoader } from '@zonofi/seller-hub/components';

interface ActionItem {
  label: string;
  onPress: () => void;
  isLoading?: boolean;
}

interface AdvancePaymentActionCardProps {
  advancePayment: number;
  advancePaymentType: 'percentage' | 'amount';
  advancePaymentAmount: number;
  actions: ActionItem[];
}

export const AdvancePaymentActionCard: React.FC<
  AdvancePaymentActionCardProps
> = ({ advancePayment, advancePaymentType, advancePaymentAmount, actions }) => {
  const advanceAmount =
    advancePaymentType === 'percentage'
      ? getFormattedAmount(advancePaymentAmount)
      : getFormattedAmount(advancePayment);

  return (
    <div className="advance-payment-action-view">
      <div className="advance-payment-action-view-left">
        <InfoIcon width={20} height={20} color="#FFFFFF" />
        <span className="advance-payment-action-view-text font-semibold">
          {`Customer must pay ${advanceAmount} in advance to accept this order.`}
        </span>
      </div>

      <div className="advance-payment-action-view-right">
        <div className="advance-payment-action-view-separator" />
        {actions.map((action, index) => (
          <div
            key={index}
            onClick={action.onPress}
            className="advance-payment-action-view-text right-text font-semibold"
          >
            {action.isLoading ? (
              <SpinnerLoader
                size={16}
                className="advance-payment-remove-loader"
                color="#fff"
              />
            ) : (
              action.label
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
